import { render } from "./ExhibitionCards.vue?vue&type=template&id=708caaa9"
import script from "./ExhibitionCards.vue?vue&type=script&lang=js"
export * from "./ExhibitionCards.vue?vue&type=script&lang=js"

import "./ExhibitionCards.vue?vue&type=style&index=0&id=708caaa9&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__